import { useEffect } from 'react';
import { useToggleState } from '../../../hooks/useToggleState';
import { trackInfoOpen } from '../tracking';

type TUseCadastralNumbersDestinationModal = [boolean, () => void];

/** Управление модалкой "Где найти номера" */
export const useCadastralNumbersDestinationModal = (): TUseCadastralNumbersDestinationModal => {
  const [modalOpened, toggleModalOpened] = useToggleState();

  useEffect(() => {
    /* istanbul ignore else */ if (modalOpened) {
      trackInfoOpen();
    }
  }, [modalOpened]);

  return [modalOpened, toggleModalOpened];
};
